import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { Snackbar, IconButton, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import RemoveIcon from "@material-ui/icons/Remove"; // minimize icon
import AddIcon from "@material-ui/icons/Add"; // expand icon
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { useLocation } from "react-router-dom";
import muteState from "../NotificationDrawer/muteState";
import { getAccessType, canAccessDigitalLock } from "../../utils/accessType"; // adjust path



const getNotificationUrl = () => {
  try {
    return (
      JSON.parse(JSON.parse(localStorage.getItem("config")).datas)
        .notificationBaseUrl + "/ws"
    );
  } catch {
    return null;
  }
};

const resolveBrokerUrl = () => {
  const accessType = getAccessType();
  // if (canAccessDigitalLock(accessType) && accessType === "ONLY_DIGITAL_LOCK") {
  //   return "wss://aisstaging.watsoo.com/backend/ws";
  // }
  return getNotificationUrl();
  // return "wss://aisstaging.watsoo.com/backend/ws"
};

const NotificationComponent = React.memo(({ enabled = true, setEvents }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [alertData, setAlertData] = useState({ type: "info", message: "" });
  // const [events, setEvents] = useState([]);
  const [muted, setMuted] = useState(muteState.get());
  const [minimized, setMinimized] = useState(false); // 👈 new state
  const queueRef = useRef([]);
  const speakingRef = useRef(false);
  const clientRef = useRef(null);
  // const showNotification = useMemo(
  //   () => ["/currentOperationalStatus"].includes(location.pathname),
  //   [location.pathname]
  // );
  const showNotification = true;

  /** 🎤 Get Hindi/Indian voice (memoized) */
  const indianVoice = useMemo(() => {
    if (!("speechSynthesis" in window)) return null;
    const voices = speechSynthesis.getVoices();
    return (
      voices.find(
        (v) => v.lang === "en-IN" || v.name.toLowerCase().includes("indian"),
      ) || null
    );
  }, []);

  /** 🎤 Speak a message */
  // const speakMessage = useCallback(
  //   (text) => {
  //     if (muted || !("speechSynthesis" in window)) return;
  //     console.log("Speaking message:", text);

  //     // ── Extract only "ALERT IGNITION_OFF HAS BEEN DETECTED" ──
  //     // let trimmed =
  //     //   text?.match(/^(.*?HAS BEEN (DETECTED|PRESSED|CLICKED))/i)?.[1]?.trim() ||
  //     //   text;

  //     let trimmed = text?.replace(/^Lock\s+\S+\s+/i, "Lock ")
  //       ?.match(/^(.*?HAS BEEN (DETECTED|PRESSED|CLICKED|LOCKED|UNLOCKED))/i)?.[1]?.trim() || text;

  //     // Clean up underscores so "IGNITION_OFF" is spoken as "IGNITION OFF"
  //     const readable = trimmed?.replace(/_/g, " ");

  //     speakingRef.current = true;
  //     speechSynthesis.cancel();

  //     const utterance = new SpeechSynthesisUtterance(readable);
  //     utterance.lang = "en-IN";
  //     utterance.rate = 0.8;
  //     utterance.pitch = 1;

  //     if (indianVoice) utterance.voice = indianVoice;

  //     utterance.onend = () => {
  //       speakingRef.current = false;
  //       setOpen(false);
  //       showNextMessage();
  //     };

  //     speechSynthesis.speak(utterance);
  //   },
  //   [indianVoice, muted, showNotification],
  // );

  const speakMessage = useCallback(
    (text) => {
      if (muted || !("speechSynthesis" in window)) return;
      console.log("Speaking message:", text);

      let cleaned = text || "";

      // ── Strip lat/lng, coordinates, and similar technical fields ──
      cleaned = cleaned
        // "lat: 28.502655, lng: 77.082944" / "latitude: X, longitude: Y"
        .replace(/\b(lat(itude)?)\s*[:=]\s*-?\d+(\.\d+)?\s*,?\s*/gi, "")
        .replace(/\b(lng|lon(gitude)?)\s*[:=]\s*-?\d+(\.\d+)?\s*,?\s*/gi, "")
        // raw coordinate pairs like "28.502655, 77.082944"
        .replace(/-?\d{1,3}\.\d{4,},\s*-?\d{1,3}\.\d{4,}/g, "")
        // "at coordinates (X, Y)" / "near (X, Y)"
        .replace(/\(?\s*-?\d{1,3}\.\d{4,}\s*,\s*-?\d{1,3}\.\d{4,}\s*\)?/g, "")
        // trailing "at/near <anything with digits and dots>" left dangling
        .replace(/\b(at|near)\s*[.,]?\s*$/i, "")
        // collapse leftover double spaces/commas from removed segments
        .replace(/\s{2,}/g, " ")
        .replace(/,\s*,/g, ",")
        .replace(/,\s*$/, "")
        .trim();

      // ── Existing: extract only the core alert phrase ──
      let trimmed =
        cleaned
          ?.replace(/^Lock\s+\S+\s+/i, "Lock ")
          ?.match(/^(.*?HAS BEEN (DETECTED|PRESSED|CLICKED|LOCKED|UNLOCKED))/i)?.[1]
          ?.trim() || cleaned;

      // Clean up underscores so "IGNITION_OFF" is spoken as "IGNITION OFF"
      const readable = trimmed?.replace(/_/g, " ");

      speakingRef.current = true;
      speechSynthesis.cancel();

      const utterance = new SpeechSynthesisUtterance(readable);
      utterance.lang = "en-IN";
      utterance.rate = 0.8;
      utterance.pitch = 1;

      if (indianVoice) utterance.voice = indianVoice;

      utterance.onend = () => {
        speakingRef.current = false;
        setOpen(false);
        showNextMessage();
      };

      speechSynthesis.speak(utterance);
    },
    [indianVoice, muted, showNotification],
  );

  /** 📢 Show next queued message */
  const showNextMessage = useCallback(() => {
    if (queueRef.current.length === 0) return;
    const next = queueRef.current.shift();
    setAlertData(next);
    setOpen(true);
    if (showNotification) {
      console.log("sdfjlsdjlsd", next.message);
      speakMessage(next.message);
    }
  }, [speakMessage, showNotification]);

  /** 📡 Setup WebSocket connection */
  useEffect(() => {
    if (!enabled || clientRef.current) return;

    const client = new Client({
      // webSocketFactory: () =>
      // new SockJS(`${JSON.parse(localStorage.getItem("config")).baseUrl}ws`),
      // new SockJS(`https://aisstaging.watsoo.com/backend/ws`),
      // wss://aisstaging.watsoo.com/backend/ws
      brokerURL: resolveBrokerUrl(),
      reconnectDelay: 5000,

      onConnect: () => {
        const subscription = client.subscribe(
          // `/topic/events/${JSON.parse(localStorage.getItem("data")).id}`,
          `/topic/events/${JSON.parse(localStorage.getItem("data")).coreUserId}`,
          // `/topic/events/54`,
          (message) => {
            const event = JSON.parse(message.body);
            const sessionData = JSON.parse(sessionStorage.getItem("data"));
            const userType = sessionData?.userType;
            const sites = sessionData?.sites || [];
            if (userType === "USER") {
              const hasSiteAccess = sites.some(
                (site) => site.id === event?.site?.id,
              );
              if (!hasSiteAccess) return; // Skip if event not relevant
            }
            const msg = event?.message || "🔔 New Alarm!";
            console.log("msgmsgmsg", msg)
            queueRef.current.push({ type: "info", message: msg });
            setEvents((prev) =>
              [
                ...prev,
                {
                  message: event.message,
                  deviceName: event.deviceName,
                  type: event.payload && JSON.parse(event.payload)?.event?.type,
                  eventType: event.eventType,
                  eventTime:
                    event.payload &&
                    JSON.parse(event.payload)?.event?.eventTime,
                  eventValue: event?.eventValue,
                  configureOverSpeedValue: event?.configureOverSpeedValue,
                  position: {
                    latitude:
                      event.payload &&
                      JSON.parse(event.payload)?.position?.latitude,
                    longitude:
                      event.payload &&
                      JSON.parse(event.payload)?.position?.longitude,
                    speed:
                      ((event.payload &&
                        JSON.parse(event.payload)?.position?.speed) ||
                        0) * 1.852,
                  },
                },
              ].sort((a, b) => new Date(b.eventTime) - new Date(a.eventTime)),
            );
            if (!speakingRef.current) showNextMessage();
          },
        );

        clientRef.current = { client, subscription };
      },

      onDisconnect: () => console.log("❌ Disconnected from WebSocket"),
    });

    client.activate();

    return () => {
      if (clientRef.current) {
        clientRef.current.subscription?.unsubscribe();
        clientRef.current.client?.deactivate();
        clientRef.current = null;
      }
    };
  }, [enabled, showNextMessage]);

  useEffect(() => {
    const unsub = muteState.subscribe(val => setMuted(val));
    return unsub;
  }, []);

  /** Snackbar close handler */
  const handleClose = useCallback(
    (event, reason) => {
      if (reason === "clickaway") return;
      setOpen(false);
      speakingRef.current = false;
      showNextMessage();
    },
    [showNextMessage],
  );

  /** 🔇 Toggle mute */
  const toggleMute = useCallback(() => {
    muteState.toggle();
    if (!muteState.get()) {          // if now unmuted → nothing to cancel
      return;
    }
    speechSynthesis.cancel();
    speakingRef.current = false;
  }, []);

  /** ➖ Toggle minimize */
  const toggleMinimize = useCallback(() => {
    setMinimized((prev) => !prev);
  }, []);

  return (
    <>
      {showNotification && (
        <Snackbar
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          style={{ marginLeft: "60px", zIndex: 100 }}
          ContentProps={{
            style: {
              width: "500px",
              maxWidth: "none",
            },
          }}
        >
          <div
            style={{
              background: "#fff",
              color: "#333",
              padding: "5px 16px",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
              maxWidth: minimized ? "200px" : "420px",
              width: "500px",
              display: "flex",
              flexDirection: "column",
              gap: minimized ? "0" : "6px",
              borderLeft: "6px solid #d32f2f",
              fontFamily: "Segoe UI, sans-serif",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <strong style={{ color: "#d32f2f", fontSize: "1rem" }}>
                🚨 Alarm
              </strong>
              <div>
                {/* Minimize/Expand Button */}
                <Tooltip title={minimized ? "Expand" : "Minimize"}>
                  <IconButton
                    size="small"
                    onClick={toggleMinimize}
                    style={{ padding: "2px", color: "#666" }}
                  >
                    {minimized ? (
                      <AddIcon fontSize="small" />
                    ) : (
                      <RemoveIcon fontSize="small" />
                    )}
                  </IconButton>
                </Tooltip>

                {/* Mute/Unmute Button */}
                <Tooltip title={muted ? "Unmute" : "Mute"}>
                  <IconButton
                    size="small"
                    onClick={toggleMute}
                    style={{
                      padding: "2px",
                      color: muted ? "#d32f2f" : "#666",
                    }}
                  >
                    {muted ? (
                      <NotificationsOffIcon fontSize="small" />
                    ) : (
                      <NotificationsActiveIcon fontSize="small" />
                    )}
                  </IconButton>
                </Tooltip>

                {/* Close Button */}
                <IconButton
                  size="small"
                  onClick={handleClose}
                  style={{ padding: "2px", color: "#666" }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>
            </div>

            {/* Only show details if not minimized */}
            {!minimized && (
              <>
                {/* Message */}
                <div
                  style={{
                    fontSize: "0.95rem",
                    lineHeight: 1.4,
                    color: "#444",
                    wordWrap: "break-word",
                  }}
                >
                  {alertData.message}
                </div>

                {/* Timestamp */}
                <div
                  style={{
                    fontSize: "0.75rem",
                    color: "#999",
                    textAlign: "right",
                  }}
                >
                  {new Date().toLocaleTimeString()}
                </div>
              </>
            )}
          </div>
        </Snackbar>
      )}
    </>
  );
});

export default NotificationComponent;
